import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, ChevronDown, ChevronUp } from 'lucide-react';

const schedule = {
  days: [
    { day: 'Day 1', date: '7/13' },
    { day: 'Day 2', date: '7/14' },
    { day: 'Day 3', date: '7/15' },
    { day: 'Day 4', date: '7/16' },
    { day: 'Day 5', date: '7/17' },
    { day: 'Day 6', date: '7/18' },
  ],
  timeSlots: [
    {
      time: '8:00–9:00',
      courses: [
        { class: '全體', content: [{ text: 'X', rowspan: 3, isExam: true }, '集合 & 早餐', '集合 & 早餐', '集合 & 早餐', '集合 & 早餐', '集合 & 早餐'] }
      ]
    },
    {
      time: '9:00–10:20',
      courses: [
        { class: '基礎', content: [null, '條件判斷/迴圈', '陣列/字串', '函式/遞迴', '資料結構', '考古題解析 (基礎)'] },
        { class: '進階', content: [null, '枚舉/二分搜', '貪心', '圖論', '動態規劃', '考古題解析 (進階)'] }
      ]
    },
    {
      time: '10:20–10:30',
      courses: [
        { class: '全體', content: [null, '休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）'] }
      ]
    },
    {
      time: '10:30–12:00',
      courses: [
        { class: '基礎', content: ['報到&開幕式(工程三館114)', '條件判斷/迴圈', '陣列/字串', '函式/遞迴', '資料結構', '考古題解析 (基礎)'] },
        { class: '進階', content: ['報到&開幕式(工程三館114)', '枚舉/二分搜', '貪心', '圖論', '動態規劃', '考古題解析 (進階)'] }
      ]
    },
    {
      time: '12:00–14:00',
      courses: [
        { class: '全體', content: ['午餐時間 & 午休', '午餐時間 & 午休', '午餐時間 & 午休', '午餐時間 & 午休', '午餐時間 & 午休', '午餐時間 & 午休'] }
      ]
    },
    {
      time: '14:00–15:20',
      courses: [
        { class: '基礎', content: ['C++基礎概念與語法', '條件判斷/迴圈', '函式/遞迴', '資料結構', '實作與除錯技巧', { text: '運算思維實作挑戰賽', rowspan: 3, isExam: true }] },
        { class: '進階', content: ['時間複雜度', '枚舉/二分搜', '貪心', '圖論', '動態規劃', { text: '運算思維實作挑戰賽', rowspan: 3, isExam: true }] }
      ]
    },
    {
      time: '15:20–15:30',
      courses: [
        { class: '全體', content: ['休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）', '休息時間（10 min）', ] },
        { class: '基礎', content: [null, null, null, null, null, null], skipRow: true },
        { class: '進階', content: [null, null, null, null, null, null], skipRow: true }
      ]
    },
    {
      time: '15:30–17:00',
      courses: [
        { class: '基礎', content: ['C++基礎概念與語法', '條件判斷/迴圈', '函式/遞迴', '資料結構', '實作與除錯技巧', ]},
        { class: '進階', content: ['時間複雜度', '枚舉/二分搜', '貪心', '圖論', '動態規劃', ]}
      ]
    },
    {
      time: '17:00–18:00',
      courses: [
        { class: '全體', content: ['自由練習', '自由練習', '自由練習', '自由練習', '自由練習', '結業式']}
      ]
    },
    {
      time: '18:00–19:00',
      courses: [
        { class: '全體', content: ['晚餐時間', '晚餐時間', '晚餐時間', '晚餐時間', '晚餐時間', { text: '賦歸', rowspan: 3 }] }
      ]
    },
    {
      time: '19:00–21:00',
      courses: [
        { class: '全體', content: ['晚間活動', '晚間活動', '晚間活動', '晚間活動', '晚間活動', ] }
      ]
    },
    {
      time: '21:00–',
      courses: [
        { class: '全體', content: ['回宿舍', '回宿舍', '回宿舍', '回宿舍', '回宿舍', ] }
      ]
    },
  ],
};

const classStyles = {
  '全體': { 
    bg: 'bg-[rgba(96,165,250,0.15)]', 
    text: 'text-[#1e293b]', 
    border: 'border-[#93c5fd]/80',
    label: 'bg-[#60a5fa] text-[#f9fafb]',
    icon: '👥'
  },
  '基礎': { 
    bg: 'bg-[rgba(96,165,250,0.1)]', 
    text: 'text-[#1e293b]', 
    border: 'border-[#93c5fd]/80',
    label: 'bg-[#93c5fd] text-[#0f172a]',
    icon: '🌱'
  },
  '進階': { 
    bg: 'bg-[rgba(96,165,250,0.1)]', 
    text: 'text-[#1e293b]', 
    border: 'border-[#93c5fd]/80',
    label: 'bg-[#60a5fa] text-[#f9fafb]',
    icon: '🔥'
  },
};


const mergeTimeSlots = (timeSlots) => {
  const merged = [];
  let i = 0;
  while (i < timeSlots.length) {
    let currentSlot = timeSlots[i];
    let rowspan = 1;
    let endTime = currentSlot.time.split('–')[1];

    // Only merge 全體 courses with identical content
    if (currentSlot.courses.every(course => course.class === '全體')) {
      while (i + 1 < timeSlots.length) {
        const nextSlot = timeSlots[i + 1];
        if (
          nextSlot.courses.every(course => course.class === '全體') &&
          JSON.stringify(currentSlot.courses[0].content) === JSON.stringify(nextSlot.courses[0].content)
        ) {
          rowspan++;
          endTime = nextSlot.time.split('–')[1];
          i++;
        } else {
          break;
        }
      }
    }

    merged.push({
      ...currentSlot,
      time: `${currentSlot.time.split('–')[0]}–${endTime}`,
      rowspan
    });
    i++;
  }
  return merged;
};

const DesktopCourses = ({ selectedClass }) => {
  const mergedTimeSlots = mergeTimeSlots(schedule.timeSlots);

  return (
    <section id="courses" className="py-16 px-8 bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-4"
      >
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent">
            課程活動
          </h2>
          <p className="text-xl text-[#475569] font-light">
            六天密集課程，涵蓋基礎到進階，結合實作與挑戰，助你掌握運算思維！
          </p>
          <div className="flex justify-center gap-4 mt-6">
            {['基礎', '進階'].map((cls) => (
              <button
                key={cls}
                onClick={() => selectedClass.set(cls)}
                className={`px-4 py-2 rounded-lg font-semibold text-sm transition-colors ${
                  selectedClass.value === cls
                    ? `${classStyles[cls].label}`
                    : 'bg-[#e0e7ff]/50 text-[#475569] hover:bg-[#93c5fd]/50'
                }`}
              >
                {classStyles[cls].icon} {cls}班
              </button>
            ))}
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="w-full overflow-x-auto rounded-xl shadow-xl border-2 border-[#93c5fd]/80 bg-[rgba(96,165,250,0.1)]"
        >
          <div className="inline-block min-w-full px-2 py-6">
            <table className="w-full border-collapse text-base">
              <thead>
                <tr className="bg-[rgba(96,165,250,0.15)] text-[#1e293b]">
                  <th className="p-3 border-2 border-[#93c5fd]/80 font-semibold text-left w-28">
                    時間
                  </th>
                  <th className="p-3 border-2 border-[#93c5fd]/80 font-semibold text-left w-24">
                    班別
                  </th>
                  {schedule.days.map((day, idx) => (
                    <th key={idx} className="p-3 border-2 border-[#93c5fd]/80 w-auto">
                      <div className="font-semibold">{day.day}</div>
                      <div className="text-sm opacity-90 mt-1 flex items-center justify-center">
                        <Calendar className="h-4 w-4 mr-1 text-[#60a5fa]" />
                        {day.date}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {mergedTimeSlots.map((slot, slotIdx) => {
                  const filteredCourses = slot.courses
                    .filter(course => (course.class === selectedClass.value || course.class === '全體') && !course.skipRow);

                  return filteredCourses.map((course, courseIdx) => (
                    <tr key={`${slotIdx}-${courseIdx}`} className="hover:bg-[rgba(96,165,250,0.05)] transition-colors">
                      {courseIdx === 0 && (
                        <td
                          rowSpan={filteredCourses.length}
                          className="p-3 border-2 border-[#93c5fd]/80 font-semibold text-[#1e293b] text-center bg-[rgba(96,165,250,0.1)] align-middle"
                        >
                          {slot.time}
                        </td>
                      )}
                      <td className="p-2 border-2 border-[#93c5fd]/80 bg-[rgba(96,165,250,0.1)] align-middle">
                        <div className={`px-3 py-1.5 rounded-lg text-center font-semibold text-sm ${classStyles[course.class].label}`}>
                          {classStyles[course.class].icon} {course.class}
                        </div>
                      </td>
                      {course.content.map((content, dayIdx) => {
                        if (content === null) return null;
                        const isObject = typeof content === 'object';
                        const text = isObject ? content.text : content;
                        const rowspan = isObject ? content.rowspan : 1;
                        const cellStyle = classStyles[course.class];
                        return (
                          <td
                            key={dayIdx}
                            rowSpan={rowspan}
                            className={`p-3 border-2 ${cellStyle.border} ${cellStyle.bg} ${cellStyle.text} align-middle font-medium text-base leading-tight`}
                          >
                            <div className="text-center">
                              {text}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

const MobileCourses = ({ selectedClass }) => {
  const [expandedDay, setExpandedDay] = useState(null);
  const mergedTimeSlots = mergeTimeSlots(schedule.timeSlots);

  return (
    <section
      id="courses"
      className="py-8 px-4 bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm"
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto"
      >
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent">
            課程活動
          </h2>
          <p className="text-base text-[#475569] font-light">
            六天密集課程，涵蓋基礎到進階，結合實作與挑戰！
          </p>
          <div className="flex justify-center gap-3 mt-4 flex-wrap">
            {['基礎', '進階'].map((cls) => (
              <button
                key={cls}
                onClick={() => selectedClass.set(cls)}
                className={`px-3 py-1.5 rounded-lg font-semibold text-sm transition-colors ${
                  selectedClass.value === cls
                    ? `${classStyles[cls].label}`
                    : 'bg-[#e0e7ff]/50 text-[#475569] hover:bg-[#93c5fd]/50'
                }`}
              >
                {classStyles[cls].icon} {cls}班
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {schedule.days.map((day, dayIdx) => (
            <motion.div
              key={dayIdx}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: dayIdx * 0.1 }}
              className="bg-[rgba(96,165,250,0.1)] border-2 border-[#93c5fd]/80 rounded-lg shadow-lg"
            >
              <button
                onClick={() =>
                  setExpandedDay(expandedDay === dayIdx ? null : dayIdx)
                }
                className="w-full p-3 flex justify-between items-center text-left"
              >
                <div>
                  <div className="font-semibold text-base">{day.day}</div>
                  <div className="text-sm text-[#475569] flex items-center mt-1">
                    <Calendar className="h-4 w-4 mr-1 text-[#60a5fa]" />
                    {day.date}
                  </div>
                </div>
                {expandedDay === dayIdx ? (
                  <ChevronUp className="h-5 w-5 text-[#60a5fa]" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-[#60a5fa]" />
                )}
              </button>

              {expandedDay === dayIdx && (
                <div className="p-3 border-t-2 border-[#93c5fd]/80">
                  {mergedTimeSlots.map((slot, slotIdx) =>
                    slot.courses
                      .filter(
                        (course) =>
                          (course.class === selectedClass.value ||
                            course.class === '全體') &&
                          !course.skipRow
                      )
                      .map((course, courseIdx) => {
                        // 修正開始：直接取得當天內容
                        const rawContent = course.content[dayIdx];

                        // 如果內容是 null，代表被合併了，手機版直接不顯示此區塊即可
                        if (!rawContent) return null;

                        // 判斷是否為物件 (有 rowspan 設定) 或純文字
                        const contentDisplay = typeof rawContent === 'object' ? rawContent.text : rawContent;
                        // 修正結束

                        return (
                          <div
                            key={`${slotIdx}-${courseIdx}`}
                            className={`p-2.5 rounded-lg ${
                              classStyles[course.class].bg
                            } border-2 ${classStyles[course.class].border} ${
                              classStyles[course.class].text
                            } mb-2`}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center">
                                <div className="text-sm font-semibold text-[#1e293b] mr-2">
                                  {slot.time}
                                </div>
                                <div
                                  className={`inline-block px-2 py-1 rounded-md text-xs font-semibold ${classStyles[course.class].label}`}
                                >
                                  {classStyles[course.class].icon} {course.class}
                                </div>
                              </div>
                            </div>
                            <div className="mt-1 text-sm text-left leading-snug">
                              {contentDisplay}
                            </div>
                          </div>
                        );
                      })
                  )}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

// Main Component
const Courses = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [selectedClass, setSelectedClass] = useState('基礎');

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? (
    <MobileCourses selectedClass={{ value: selectedClass, set: setSelectedClass }} />
  ) : (
    <DesktopCourses selectedClass={{ value: selectedClass, set: setSelectedClass }} />
  );
};

export default Courses;